module.exports = __webpack_public_path__ + "static/media/Habitat_PictoCdlT.fd94b252.png";